<app-common-modal-form
  icon="ic-edit-20"
  [subheader]="subheader"
  [header]="titleFormControl.value ?? ''"
  [isLoading]="isLoading"
  (confirm)="confirm()"
  (close)="close()"
>
  <div class="confirm-button">
    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center gap-2"
      [hidden]="!editedCoverLetter"
      [disabled]="isLoading"
      (click)="deleteTemplate()"
    >
      <i class="icon ic-trash-20"></i>
      <span>Delete</span>
    </button>
  </div>

  <div class="cover-letter-modal">
    <div class="form-group">
      <app-input
        label="Title"
        [formControl]="titleFormControl"
        [customErrors]="titleControlCustomErrors"
      />
    </div>

    @if (fileToUpload) {
      <div class="attached-file-label" (click)="$event.stopPropagation(); $event.preventDefault()">
        <app-file-label
          [showControlsOnlyOnHover]="false"
          [hideDeleteBtn]="!!editedCoverLetter"
          (downloadFile)="downloadFile()"
          (deleteFile)="fileToUpload = null"
        >
          {{ fileToUpload.fileName }}
        </app-file-label>
      </div>
    } @else {
      <div class="form-group">
        <app-file-upload
          label="Template"
          [isLoading]="isLoading"
          [multiple]="false"
          [acceptedFormatsList]="acceptedFormatsList"
          (change)="onFilesLoaded($event)"
        />
      </div>
    }

    @if (errorMessage) {
      <app-disclaimer color="red">{{ errorMessage }}</app-disclaimer>
    }
  </div>
</app-common-modal-form>
